"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _functions = require("./functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-chcydsb"
});

/**
 * AnimatedContainer Component.
 *
 * @param {Object} props React props
 * @param {Function} props.animate Getter for the animation style
 * @param {Node} props.children Child of the AnimatedContainer
 * @returns {React.ReactElement} AnimatedContainer Component
 * @public
 */

function AnimatedContainer({
  animate,
  children
}) {
  const ref = (0, _react.useRef)();
  const isInView = (0, _functions.useIsInView)(ref);
  return /*#__PURE__*/_react.default.createElement(Container, {
    ref: ref,
    style: animate(isInView),
    "data-cy": "animated-container"
  }, children);
}
var _default = exports.default = AnimatedContainer;
AnimatedContainer.propTypes = {
  children: _propTypes.default.node.isRequired,
  animate: _propTypes.default.func.isRequired
};